import { Container, Typography, Grid } from "@mui/material";
import React, { useState } from "react";
import HeaderTitle from "../../common/HeaderTitle";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ProfileService from "../services/ProfileService";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { userActions } from "../../../redux/features/user/userSlice";
import RichTextEditor from "../../common/RichTextEditor";
import { SnackbarAlert } from "../../common/SnackbarAlert";
import { snackbarActions } from "../../../redux/features/snackbar/snackbarSlice";

const ShippingPolicy = (props: any) => {

    const { showSnackbar, handleLoader } = props;

    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();

    const shipping = useAppSelector((state) => state.user.userDetails?.store?.[0].policy?.shippingPolicy) ?? null;
    const [alertMessage, setAlertMessage] = useState<string>();
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [success, setSuccess] = useState(false);

    const setMessage = (msg: string) => {
        setAlertMessage(msg);
        setOpenSnackBar(true);
    };

    const saveShipping = (data: any) => {
        handleLoader(true);
        dispatch(userActions.SAVE_SHIPPING_POLICY(data));
        const payload = { shippingPolicy: data };
        const isHitDummyURL = false;

        new ProfileService(payload, isHitDummyURL).sellerBussinessInfo().then(res => {
            handleLoader(false);
            showSnackbar(res, true);
        }).catch(err => {
            handleLoader(false);
            showSnackbar(err?.message, false);
        });

    };

    const handleCloseSnackBar = () => {
        setOpenSnackBar(false);
    };

    return (
        <>
            {/* Page header title */}

            <HeaderTitle title={t("profile.shipping_policy")}/>

            {/* Page header title */}

            <Container>
                <Typography variant="h6" sx={{ my: 2 }}>
                    {t("profile.shipping_policy")}
                </Typography>
                <RichTextEditor data={shipping} saveData={saveShipping} />
                <SnackbarAlert
                    openSnackBar={openSnackBar}
                    message={alertMessage}
                    success={success}
                    handleCloseSnackBar={handleCloseSnackBar}
                />
            </Container>
        </>
    );
};

export default ShippingPolicy;
